module.exports = __webpack_public_path__ + "img/next_level_section.8c94180e.webp";